// Paleta de cores extraída da imagem de referência

const colors = {
  // Cores principais
  darkPurple: '#1A0B2E', // Fundo escuro (roxo muito escuro)
  brightPink: '#FF3D6E', // Rosa vibrante (esquerda do logo)
  lightPink: '#E16B9F', // Rosa claro (meio do logo)
  purple: '#9C6BDF', // Roxo médio (meio do logo)
  lightPurple: '#B38AED', // Roxo claro (nós da rede)
  skyBlue: '#4ECFEA', // Azul claro (direita do logo)
  
  // Cores secundárias
  white: '#FFFFFF',
  lightGray: '#F5F5F7',
  darkGray: '#333333',
  
  // Gradientes
  gradientPrimary: 'linear-gradient(90deg, #FF3D6E 0%, #B38AED 50%, #4ECFEA 100%)',
  gradientButton: 'linear-gradient(90deg, #9C6BDF 0%, #4ECFEA 100%)',
};

export default colors;
